import Layout from '@/components/layout/Layout.vue'
import { getMediaAccounts } from '@/api/open'
import { pullAdvertisers } from '@/api/advertiser'

export default {
    components: {
        Layout
    },
    props: {
        type: {
            type: String,
            required: true
        },
        showForm: {
            type: Boolean,
            required: true
        },
        oauthType: {
            type: String,
            default: 'advertiser'
        },
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            model: {},
            accounts: [],
            loading: false,
            rules: {
                account_id: [ { required: true, message: '请选择授权账号', trigger: 'change' }],
            }
        }
    },
    computed: {
    },
    mounted () {
        this.loading = true
        getMediaAccounts({ media: this.$helper.getMediaId(this.type) }).then(res => {
            this.accounts = res.data.list || []
        }).finally(() => {
            this.loading = false
        })
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.pull()
            });
        },
        pull() {
            const params = { ...this.model, oauth_type: this.oauthType }
            window.open(pullAdvertisers(params, this.type))
            this.close()
        },
        close() {
            this.$emit('update:showForm', false)
            this.$refs.form.resetFields()
        }
    }
}
